<template>
	<div class="p-grid nested-grid">
		<div class="p-col-2"></div>
		<div class="p-col-8">
			<div class="p-col-12 p-text-center">
				แบบประเมินเพื่อพัฒนาสมรรถนะและวางแผนพัฒนารายบุคคล
			</div>
			<div class="=p-col-12 p-text-center">
				ประเมินประจำปี {{ fiscalYear() }}
			</div>
		</div>
		<div class="p-col-2"></div>
	</div>
	<div class="p-grid">
		<div class="p-col-fixed" style="width: 30px" />
		<div class="p-col-1">รหัสประจำตัว</div>
		<div class="p-col-10">0173</div>
		<div class="p-col-fixed" style="width: 30px" />
	</div>
	<div class="p-grid">
		<div class="p-col-fixed" style="width: 30px" />
		<div class="p-col-1">ชื่อ-นามสกุล</div>
		<div class="p-col-4">นายอำนาจ สว่างรุ่งเรือง</div>
		<div class="p-col-1" />
		<div class="p-col-1">ตำแหน่ง</div>
		<div class="p-col-4">ผู้จัดการสาขา</div>
		<div class="p-col-fixed" style="width: 30px" />
	</div>
	<div class="p-grid">
		<div class="p-col-fixed" style="width: 30px" />
		<div class="p-col-1">แผนก</div>
		<div class="p-col-4"></div>
		<div class="p-col-1" />
		<div class="p-col-1">ฝ่าย</div>
		<div class="p-col-4"></div>
		<div class="p-col-fixed" style="width: 30px" />
	</div>
	<div>
		<Accordion :multiple="true">
			<AccordionTab header="คำแนะนำ">
				<div class="p-grid">
					<div class="p-col-fixed" style="width: 10px" />
					<div class="p-col-11">
						ในการประเมินสมรรถนะหลัก สมรรถนะผู้นำ ทั้งผู้บังคับบัญชาและพนักงาน
						ควรพิจารณาแนวทางดังต่อไปนี้
					</div>
					<div class="p-col-fixed" style="width: 10px" />
				</div>
				<div class="p-grid">
					<div class="p-col-fixed" style="width: 10px" />
					<div class="p-col-11">
						1. ศึกษาความหมายของสมรรถนะ และบทบาทของแต่ละระดับตำแหน่ง ดังนี้
					</div>
					<div class="p-col-fixed" style="width: 10px" />
				</div>
				<div class="p-grid">
					<div class="p-col-fixed" style="width: 10px" />
					<div class="p-col-11">1.1 ความหมายของสมรรถนะ</div>
					<div class="p-col-fixed" style="width: 10px" />
				</div>
				<div class="p-grid">
					<div class="p-col" style="width: 10px"></div>
					<div class="card" style="width: 100%">
						<div class="p-grid">
							<div class="p-col-6" style="background-color: #b7ccf0fa">
								<div>สมรรถนะหลัก (Core Competency) : TASTE</div>
								<div class="text-highlight">
									ทีมงานร่วมใจ (Teamwork and Collaboration)
								</div>
								<div class="p-grid">
									<div class="p-col-1 text-underline">นิยาม</div>
									<div class="p-col-11">
										<ul id="taglist">
											<li>รักสามัคคี พร้อมร่วมมือช่วยเหลือทีมงาน</li>
											<li>เปิดใจรับฟังข้อเสนอแนะของทีมงาน</li>
											<li>ร่วมรับผิดรับชอบกับทีมงาน</li>
											<li>ให้ความนับถือและชื่นชมทีมทั้งต่อหน้าและลับหลัง</li>
											<li>ร่วมมือ สร้างเครือข่ายพันธมิตร กับองค์กรภายนอก</li>
											<li>
												สร้างความร่วมมือในกลุ่มธุรกิจ (COKE Corporate Alignment)
											</li>
										</ul>
									</div>
								</div>
								<div class="text-highlight">
									ใฝ่เรียนรู้เป็นนิจ (Ability to Learn)
								</div>
								<div class="p-grid">
									<div class="p-col-1 text-underline">นิยาม</div>
									<div class="p-col-11">
										<ul id="taglist">
											<li>
												เปิดรับสิ่งใหม่
												เรียนรู้และก้าวทันความรู้เทคโนโลยีที่ใช้ในงานความเชื่อมโยงกับความรู้อื่น
											</li>
											<li>
												ปรับประยุกต์ใช้ความรู้ของตนเองและรวมกับความรู้อื่นเพื่อเพิ่มคุณค่า(Value)
												ต่องานและธุรกิจ
											</li>
											<li>เรียนรู้ด้วยตนเองและพร้อมแลกเปลี่ยนเรียนรู้</li>
										</ul>
									</div>
								</div>
								<div class="text-highlight">
									คิดอย่างผู้ประกอบการ (Seek Opportunity and Act as an
									Entrepreneur)
								</div>
								<div class="p-grid">
									<div class="p-col-1 text-underline">นิยาม</div>
									<div class="p-col-11">
										<ul id="taglist">
											<li>รัก ภูมิใจในงานและบริษัท</li>
											<li>ทำงานอย่างมุ่งมั่นทุ่มเทสู่ผลลัพธ์ที่เลิศ</li>
											<li>
												ตั้งต้นคิดงานจากลูกค้า/ผู้บริโภคและจบที่ส่งมอบผลงานดีเยี่ยม
											</li>
											<li>
												ทำงานยากให้ง่าย
												มุ่งเน้นผลงานที่ลูกค้า/ผู้บริโภคและผู้รับบริการ (Outside
												in)
											</li>
											<li>แสวงหาโอกาสในการสร้างสรรค์ผลงานอย่างเจ้าของงาน</li>
											<li>
												เสนอสินค้าบริการที่สร้างผลตอบแทนสูง (Business
												Optimization)
											</li>
										</ul>
									</div>
								</div>
								<div class="text-highlight">
									สรรค์สร้างสิ่งใหม่ (Think Positively and Act Innovatively)
								</div>
								<div class="p-grid">
									<div class="p-col-1 text-underline">นิยาม</div>
									<div class="p-col-11">
										<ul id="taglist">
											<li>มองโลกจากความจริง หามุมบวก และมีความสนุกกับงาน</li>
											<li>
												คิดใหญ่ กล้านำเสนอความคิด และกล้ารับความเสี่ยงที่จะทำ
											</li>
											<li>
												สร้างนวัตกรรมที่อาจจะเป็นกระบวนการทำงาน สินค้าหรือบริการ
												และรูปแบบธุรกิจใหม่ (Process/ Product/ Services/
												Business Innovation)
											</li>
										</ul>
									</div>
								</div>
								<div class="text-highlight">
									มีใจคุณธรรม (Ethics and Integrity)
								</div>
								<div class="p-grid">
									<div class="p-col-1 text-underline">นิยาม</div>
									<div class="p-col-11">
										<ul id="taglist">
											<li>ปฏิบัติตามกฎระเบียบจริยธรรมธุรกิจ</li>
											<li>เสียสละช่วยเหลือแบ่งปันผู้อื่น และตอบแทนสังคม</li>
											<li>คิด-พูด-ทำ ด้วยหลักคุณธรรมความถูกต้องและยุติธรรม</li>
											<li>อ่อนน้อมให้เกียรติผู้อื่นและผู้อาวุโสกว่า</li>
										</ul>
									</div>
								</div>
							</div>
							<div class="p-col-6" style="background-color: #e9f149fa">
								<div>สมรรถนะผู้นำ (Leadership Competency) : LEAD</div>
								<div class="text-highlight">
									กล้านำการเปลี่ยนแปลง (Leading Change)
								</div>
								<div class="p-grid">
									<div class="p-col-1 text-underline">นิยาม</div>
									<div class="p-col-11">
										<ul id="taglist">
											<li>รู้เท่าทันการเปลี่ยนแปลงจากภายนอก</li>
											<li>เปลี่ยนแปลงตนเอง ทีมงานให้ทัน</li>
											<li>
												สื่อสารโน้มน้าวสร้างแรงบันดาลใจและบริหารการเปลี่ยนแปลง
											</li>
											<li>
												สร้างทัศนะให้ตนเอง-ทีมงานมองการเปลี่ยนแปลงเป็นการแสวงหาโอกาส
											</li>
										</ul>
									</div>
								</div>
								<div class="text-highlight">
									แสดงวิสัยทัศน์ (Establishing Vision and Business Strategy)
								</div>
								<div class="p-grid">
									<div class="p-col-1 text-underline">นิยาม</div>
									<div class="p-col-11">
										<ul id="taglist">
											<li>
												มองกว้าง เห็นไกล เห็นก่อน
												นำมาใช้ประโยชน์ในการทำงานและธุรกิจ
											</li>
											<li>
												พัฒนามุมมองเป็นกลยุทธ์ในการทำงาน /
												ธุรกิจที่ใช้ทรัพยากรในการน้อยทำงาน แต่ส่งผลมาก
											</li>
											<li>จัดการทำงานของตนและทีมงานให้สอดคล้องกับแผนกลยุทธ์</li>
											<li>
												สื่อสารกลยุทธ์
												สร้างการยอมรับเกิดความร่วมมือในการนำกลยุทธ์สู่การปฏิบัติ
											</li>
										</ul>
									</div>
								</div>
								<div class="text-highlight">
									แน่ชัดแล้วตัดสินใจ (Acting as a Problem Solver)
								</div>
								<div class="p-grid">
									<div class="p-col-1 text-underline">นิยาม</div>
									<div class="p-col-11">
										<ul id="taglist">
											<li>ปฏิบัติงานเชิงรุกโดยการใช้ข้อมูลหลักการ</li>
											<li>
												เข้าหาสาเหตุของปัญหา ความท้าทาย โดยมองเห็นเป็นโอกาส
											</li>
											<li>
												เป็นนักแก้ปัญหาที่กล้าตัดสินใจ และรับผิดชอบต่อผลลัพธ์
											</li>
											<li>
												บริหารความเสี่ยง เผชิญสถานการณ์วิกฤตอย่างยืนหยัดมั่นคง
											</li>
										</ul>
									</div>
								</div>
								<div class="text-highlight">
									ใส่ใจพัฒนาทีม (Developing Others)
								</div>
								<div class="p-grid">
									<div class="p-col-1 text-underline">นิยาม</div>
									<div class="p-col-11">
										<ul id="taglist">
											<li>
												มีเป้าหมายและวิธีการพัฒนาตัวเองและทีมงาน เช่น
												การสอนงานการโค้ช และอื่นๆ
											</li>
											<li>
												สามารถเลือกใช้เทคนิคในการพัฒนาทีมงานให้เหมาะสมกับเรื่อง-บุคคล-ทรัพยากร
											</li>
											<li>สร้างหาดทิพย์เป็นองค์การแห่งการเรียนรู้</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="p-col" style="width: 10px"></div>
				</div>
				<div class="p-grid">
					<div class="p-col-fixed" style="width: 10px" />
					<div class="p-col-11">1.2 บทบาทของแต่ละระดับตำแหน่ง</div>
					<div class="p-col-fixed" style="width: 10px" />
				</div>
				<div class="p-grid">
					<!-- <div class="p-col" style="width: 10px"></div> -->
					<div class="p-col-2">
						<Panel header="เจ้าหน้าที่/พนักงาน (Well Learned Practitioner)">
							<ul>
								<li>เรียนรู้ได้</li>
								<li>พร้อมลงมือทำ</li>
								<li>ร่วมมือกับทีม</li>
								<li>พัฒนาตนเอง</li>
							</ul>
						</Panel>
					</div>
					<div class="p-col-2">
						<Panel header="หัวหน้าหน่วย (Team Leader)">
							<ul>
								<li>เชี่ยวชาญ</li>
								<li>รู้ลึกถึงการจัดการ</li>
								<li>รสอนพัฒนาผู้อื่น</li>
								<li>สร้างการยอมรับ (Trust)</li>
							</ul>
						</Panel>
					</div>
					<div class="p-col-2">
						<Panel header="ผู้จัดการแผนก (Multi Team Leader)">
							<ul>
								<li>รอบรู้ (กว้าง) เชื่อมโยง ความรู้</li>
								<li>นำมาประยุกต์ใช้</li>
								<li>จูงใจทีม</li>
							</ul>
						</Panel>
					</div>
					<div class="p-col-2">
						<Panel header="ผู้จัดการฝ่าย (Cross Company Leader)">
							<ul>
								<li>บริหารภาพรวมแผน</li>
								<li>พัฒนารูปแบบงาน</li>
								<li>สร้างแรงบันดาลใจ (Passion)</li>
								<li>ทันต่อการเปลี่ยนแปลง</li>
								<li>บริหารการเปลี่ยนแปลงให้เกิดขึ้น</li>
							</ul>
						</Panel>
					</div>
					<div class="p-col-2">
						<Panel
							header="ผู้อำนวยการ (Strategic Execution & Change Maker)"
							id="mystyleClass"
						>
							<ul>
								<li>บริหารแผนปฏิบัติการเพื่อบรรลุแผนกลยุทธ์</li>
								<li>สร้างนวัตกรรม</li>
								<li>นำการเปลี่ยนแปลงให้เกิดอย่างราบรื่น</li>
							</ul>
						</Panel>
					</div>
					<div class="p-col-2">
						<Panel header="SVP/VP/AVP (Disrupter Strategist)">
							<ul>
								<li>เห็นภาพอนาคต</li>
								<li>เสนอกลยุทธ์</li>
								<li>สร้างวัฒนธรรมองค์กร</li>
							</ul>
						</Panel>
					</div>
					<!-- <div class="p-col-2">
						<Card>
							<template #header
								>เจ้าหน้าที่/พนักงาน (Well Learned Practitioner)</template
							>
							<template #content>
								<ul>
									<li>เรียนรู้ได้</li>
									<li>พร้อมลงมือทำ</li>
									<li>ร่วมมือกับทีม</li>
									<li>พัฒนาตนเอง</li>
								</ul>
							</template>
						</Card>
					</div>
					<div class="p-col-2">
						<Card style="background: red">
							<template #header>หัวหน้าหน่วย (Team Leader) </template>
							<template #content>
								<ul>
									<li>เชี่ยวชาญ</li>
									<li>รู้ลึกถึงการจัดการ</li>
									<li>รสอนพัฒนาผู้อื่น</li>
									<li>สร้างการยอมรับ (Trust)</li>
								</ul>
							</template>
						</Card>
					</div>
					<div class="p-col-2">
						<Card class="mystyleClass">
							<template #header>ผู้จัดการแผนก (Multi Team Leader)</template>
							<template #content>
								<ul>
									<li>รอบรู้ (กว้าง) เชื่อมโยง ความรู้</li>
									<li>นำมาประยุกต์ใช้</li>
									<li>จูงใจทีม</li>
								</ul>
							</template>
						</Card>
					</div>
					<div class="p-col-2">
						<Card style="mystyleClass">
							<template #header>ผู้จัดการฝ่าย (Cross Company Leader)</template>
							<template #content>
								<ul>
									<li>บริหารภาพรวมแผน</li>
									<li>พัฒนารูปแบบงาน</li>
									<li>สร้างแรงบันดาลใจ (Passion)</li>
									<li>ทันต่อการเปลี่ยนแปลง</li>
									<li>บริหารการเปลี่ยนแปลงให้เกิดขึ้น</li>
								</ul>
							</template>
						</Card>
					</div>
					<div class="p-col-2">
						<Card class="mystyleClass">
							<template #header
								>ผู้อำนวยการ (Strategic Execution & Change Maker)</template
							>
							<template #content>
								<ul>
									<li>บริหารแผนปฏิบัติการเพื่อบรรลุแผนกลยุทธ์</li>
									<li>สร้างนวัตกรรม</li>
									<li>นำการเปลี่ยนแปลงให้เกิดอย่างราบรื่น</li>
								</ul>
							</template>
						</Card>
					</div>
					<div class="p-col-2">
						<Card class="mystyleClass">
							<template #header>SVP/VP/AVP (Disrupter Strategist)</template>
							<template #content>
								<ul>
									<li>เห็นภาพอนาคต</li>
									<li>เสนอกลยุทธ์</li>
									<li>สร้างวัฒนธรรมองค์กร</li>
								</ul>
							</template>
						</Card>
					</div> -->

					<!-- <div class="p-col" style="width: 10px"></div> -->
				</div>
				<br />
				<div class="p-grid">
					<div class="p-col-fixed" style="width: 10px" />
					<div class="p-col-11">
						2. พนักงานประเมินตนเองโดยใช้ระดับคะแนน 6
						ตามความหมายข้างล่างนี้แล้วจึงนำไปสรุปผลกับผู้บังคับบัญชา
						<ol>
							<li>
								หมายถึง แสดงออกให้เห็นและมีผลลัพธ์น้อยไม่ชัดเจน หรือน้อยกว่า 50%
							</li>
							<li>
								หมายถึง แสดงออกให้เห็นและมีผลลัพธ์บ้างยังไม่ชัดเจน หรือ 51 – 64%
							</li>
							<li>
								หมายถึง แสดงออกให้เห็นและมีผลลัพธ์บ่อยชัดเจน หรือ 65 – 74%
							</li>
							<li>
								หมายถึง แสดงออกให้เห็นและมีผลลัพธ์สม่ำเสมอชัดเจน หรือ 75 – 84%
							</li>
							<li>
								หมายถึง
								แสดงออกให้เห็นและมีผลลัพธ์สม่ำเสมอชัดเจนเป็นตัวอย่างของหน่วยงาน
								หรือ 85 – 94%
							</li>
							<li>
								หมายถึง
								แสดงออกให้เห็นและมีผลลัพธ์เป็นปกติวิสัยชัดเจนเป็นตัวอย่างที่ดีขององค์กร
								หรือ 95 – 100%
							</li>
						</ol>
					</div>
					<div class="p-col-fixed" style="width: 10px" />
				</div>
				<div class="p-grid">
					<div class="p-col-fixed" style="width: 10px" />
					<div class="p-col-6">
						3. กรณีประเมินระดับคะแนน 5 – 6
						ขอให้ระบุพฤติกรรมและผลลัพธ์เป็นตัวอย่างโดยใช้หลัก STAR คือ
					</div>
					<div class="p-col-5 text-highlight text-underline">ตัวอย่าง</div>
					<div class="p-col-fixed" style="width: 10px" />
				</div>
				<!-- <div class="p-grid">
					<div class="p-col-fixed" stype="width:10px" />

					<div class="p-col-6" />
					<div class="p-col-5 text-highlight text-underline">ตัวอย่าง</div>
				</div> -->
				<div class="p-grid">
					<div class="p-col-fixed" style="width: 30px" />
					<div class="p-col-6">S = Situation ระบุสถานการณ์</div>
					<div class="p-col-5 text-highlight">
						S : ตามแผนธุรกิจต้องการทำโปรโมชั่นสินค้ากับร้านค้าผ่าน Application
					</div>
					<div class="p-col-fixed" style="width: 10px" />
				</div>
				<div class="p-grid">
					<div class="p-col-fixed" style="width: 30px" />
					<div class="p-col-6">T = Task ระบุว่าเป็นงานใด</div>
					<div class="p-col-5 text-highlight">
						T : ซึ่งคุณ ก. มีหน้าที่ต้องผลักดันเรื่องนี้ให้ได้ผลภายในไตรมาสที่ 1
					</div>
					<div class="p-col-fixed" style="width: 10px" />
				</div>
				<div class="p-grid">
					<div class="p-col-fixed" style="width: 30px" />
					<div class="p-col-6">
						A = Action ระบุว่า คิด พูด การกระทำ ที่แสดงออกในงานนั้นอย่างไร
					</div>
					<div class="p-col-5 text-highlight">
						A : คุณ ก. จัดเป็น Cross Functional Team ภายใน ลูกค้า และ Software
						ภายนอกเพื่อพัฒนาระบบ
					</div>
					<div class="p-col-fixed" style="width: 10px" />
				</div>
				<div class="p-grid">
					<div class="p-col-fixed" style="width: 30px" />
					<div class="p-col-6">R = Results ระบุผลลัพธ์ที่เกิดขึ้น</div>
					<div class="p-col-5 text-highlight">
						R : สามารถดำเนินการได้ผลดีภายในไตรมาสที่ 1
					</div>
					<div class="p-col-fixed" style="width: 10px" />
				</div>
			</AccordionTab>
			<AccordionTab header="ส่วนที่ 1 สมรรถนะหลัก (Core Competency) : TASTE">
				<CompentencyHeaderTitle :items="assmtTemplateP1" />
			</AccordionTab>
			<AccordionTab
				header="ส่วนที่ 2 สมรรถนะสำหรับผู้บริหาร/ผู้นำ (Leadership Competency) : LEAD"
			>
				<CompentencyHeaderTitle :items="assmtTemplateP2" />
			</AccordionTab>
			<AccordionTab
				header="ส่วนที่ 3 สมรรถนะเฉพาะกลุ่มงาน (Functional Competency)"
			>
				<CompentencyHeaderTitle :items="assmtTemplateP3" />
			</AccordionTab>
			<AccordionTab
				header="ส่วนที่ 4 วางแผนการพัฒนาพนักงานรายบุคคล (Individual Development Plan)"
			>
				Content
			</AccordionTab>
		</Accordion>
	</div>
</template>

<script lang="ts">
	import Accordion from "primevue/accordion";
	import Card from "primevue/card";
	import Divider from "primevue/divider";
	import Panel from "primevue/panel";
	import CompentencyHeaderTitle from "@/components/CompentencyHeaderTitle.vue";

	import { usePlugin } from "@/plugins";
	import {
		defineComponent,
		// watch,
		// computed,
		// ref,
		// onBeforeUpdate,
		// onMounted,
		// reactive,
		ref,
	} from "vue";

	export default defineComponent({
		name: "compentencyAssessment",
		components: {
			CompentencyHeaderTitle,
		},
		setup() {
			const { dayjs } = usePlugin();
			const fiscalYear = () => dayjs().toDate().getFullYear() + 543;

			const assmtTemplateP1 = ref([
				{
					abbrv: "T",
					desc: "ทีมงานร่วมใจ (Teamwork and Collaboration)",
					taskDescs: [
						{ taskDesc: "จัดการทำงานและติดตามงานของทีม" },
						{ taskDesc: "สร้างความร่วมมือระหว่างทีม" },
						{ taskDesc: "ชื่นชม สร้างแรงจูงใจในการทำงานเป็นทีม" },
						{ taskDesc: "ร่วมสุขร่วมทุกข์และร่วมรับผิดชอบกับทีมงาน" },
					],
				},
				{
					abbrv: "A",
					desc: "ใฝ่เรียนรู้เป็นนิจ (Ability to Learn)",
					taskDescs: [
						{ taskDesc: "สามารถประยุกต์ใช้ความรู้ให้เกิดผลงานอย่างโดดเด่น" },
						{
							taskDesc:
								"เรียนรู้อย่างลึกซึ้งและเชื่อมโยงความรู้ด้านอื่นๆเพื่อการทำงานภาพรวมอย่างมีประสิทธิภาพ",
						},
						{
							taskDesc:
								"สร้างความไว้วางใจและบรรยากาศที่เอื้อต่อการแลกเปลี่ยนเรียนรู้ของทีม",
						},
					],
				},
				{
					abbrv: "S",
					desc:
						"คิดอย่างผู้ประกอบการ (Seek Opportunity and Act as an Entrepreneur)",
					taskDescs: [
						{
							taskDesc:
								"แสวงหาโอกาสในการทำงานเพื่อประโยชน์ของธุรกิจอย่างผู้ประกอบการ",
						},
						{
							taskDesc:
								"สร้างแรงจูงใจและสนับสนุนทีมงานให้ทำงานอย่างทุ่มเทให้เกิดผลอย่างชัดเจนที่ลูกค้า/ผู้รับบริการ",
						},
					],
				},
				{
					abbrv: "T",
					desc: "สรรค์สร้างสิ่งใหม่ (Think Positively and Act Innovatively)",
					taskDescs: [
						{
							taskDesc:
								"เป็นตัวอย่างการเป็นนักสร้างสรรค์สิ่งใหม่ด้วยตนเอง ที่มีผลงาน  Process/ Product/ Services หรือ Business  Innovation",
						},
						{ taskDesc: "จูงใจทีมงานให้กล้าคิดและสนุกกับการสร้างสรรค์นวัตกรรม" },
					],
				},
				{
					abbrv: "T",
					desc: "มีใจคุณธรรม (Ethics and Integrity) ",
					taskDescs: [
						{
							taskDesc:
								"คิด พูด ทำ ถูกต้องด้วยหลักยุติธรรม คุณธรรม และความถูกต้อง",
						},
						{
							taskDesc:
								"สร้างแรงจูงใจให้ทีมงานคิด พูด ทำ ตามกฎระเบียบจริยธรรมธุรกิจ",
						},
					],
				},
			]);

			const assmtTemplateP2 = ref([
				{
					abbrv: "L",
					desc: "กล้านำการเปลี่ยนแปลง (Leading Change)",
					taskDescs: [
						{ taskDesc: "เท่าทันการเปลี่ยนแปลงแต่ละด้านโดยเฉพาะเทคโนโลยี" },
						{ taskDesc: "จูงใจให้ทีมงานเห็นความจำเป็นในการเปลี่ยนแปลง" },
					],
				},
				{
					abbrv: "E",
					desc: "แสดงวิสัยทัศน์ (Establishing Vision and Business Strategy)",
					taskDescs: [
						{ taskDesc: "พัฒนามุมมองให้กว้างไกลเห็นภาพรวมอุตสาหกรรม" },
						{
							taskDesc:
								"พัฒนากลยุทธ์ในการทำงานร่วมกันระหว่างทีมเพื่อ “ทำน้อยแต่ได้ผลมาก",
						},
						{
							taskDesc:
								"สื่อสารสร้างแรงจูงใจให้ทีมงานทุ่มเท และมุ่งที่เป้าหมายกลยุทธ์ธุรกิจ",
						},
					],
				},
				{
					abbrv: "A",
					desc: "แน่ชัดแล้วตัดสินใจ (Acting as a Problem Solver)",
					taskDescs: [
						{
							taskDesc:
								"ใช้ข้อมูลในการวิเคราะห์คาดการณ์เพื่อการตัดสินใจในงานและการแก้ปัญหา",
						},
						{
							taskDesc:
								"วางแผนงานและแผนความเสี่ยงในงานโดยใช้การวิเคราะห์ข้อมูลและการคาดการณ์ (Analytic)",
						},
						{
							taskDesc: "สร้างแรงจูงใจให้ทีมงานทำงานเชิงรุก พร้อมเผชิญความท้าทาย",
						},
					],
				},
				{
					abbrv: "D",
					desc: "ใส่ใจพัฒนาทีม (Developing Others)",
					taskDescs: [
						{
							taskDesc:
								"มีความรู้ในงาน เปิดรับความรู้อื่นที่สามารถเชื่อมโยงกับการทำงาน",
						},
						{
							taskDesc:
								"สามารถสอนงาน เป็นพี่เลี้ยงและเป็นโค้ช โดยเลือกใช้ได้เหมาะสมกับสถานการณ์",
						},
						{
							taskDesc:
								"จูงใจให้เกิดการเรียนรู้ด้วยตนเองและมีการแลกเปลี่ยนเรียนรู้",
						},
					],
				},
			]);

			const assmtTemplateP3 = ref([
				{
					abbrv: "1",
					desc: "ความรู้เกี่ยวกับงานและธุรกิจบริษัท",
					taskDescs: [
						{ taskDesc: "รอบรู้ภาพรวมบริษัท ช่องทางการขายทั้งหมดใน TT" },
					],
				},
				{
					abbrv: "2",
					desc:
						"ความรู้ด้านผลิตภัณฑ์/Pack size/ช่องทาง/ราคา (BPPC) และ Promotion",
					taskDescs: [
						{
							taskDesc:
								"รอบรู้ผลิตภัณฑ์/Pack size/ช่องทาง/ราคา (BPPC) และ Promotion ของ TT บางหน่วย",
						},
					],
				},
				{
					abbrv: "3",
					desc: "ทักษะการขับรถขนส่งสินค้า",
					taskDescs: [
						{ taskDesc: "สามารถขับรถขนส่งสินค้าและดูแลรักษารถเบื้องต้น" },
					],
				},
				{
					abbrv: "4",
					desc: "ความรู้ด้านความเคลื่อนไหวของตลาด/คู่แข่ง",
					taskDescs: [
						{
							taskDesc:
								"รวบรวมข้อมูล วิเคราะห์ความเคลื่อนไหวของตลาด/คู่แข่งในพื้นที่",
						},
					],
				},
			]);

			return {
				fiscalYear,
				assmtTemplateP1,
				assmtTemplateP2,
				assmtTemplateP3,
			};
		},
	});
</script>

<style lang="scss" scope >
	.text-highlight {
		color: red;
	}
	.p-card .p-card-heaer {
		background: red;
		// height: 150px;
	}
	.mystyleClass .p-card-content {
		background: blue;
	}
	.mystyleClass .p-card-header {
		background-color: red;
	}
	.p-card {
		height: 100%;
	}
	#taglist {
		display: inline;
		list-style-type: ": ";
		/* margin: 0; */
		padding: 0;
		/* border: 0; */
	}
	.text-underline {
		text-decoration: underline;
	}
</style>
